import React from 'react';

export const Mapping = ({ dictionary, word }) => {
	return <React.Fragment>{mapping({ dictionary, word })}</React.Fragment>;
};

export const mapping = ({ dictionary, word }) => {
	var value = dictionary ? dictionary[word] : word;
	if (!value) {
		return 'KEY_NOT_FOUND';
	} else if (typeof value === 'string' || value instanceof String) {
		return value;
	}
};

export default Mapping;
